export const TRANSACTION_HISTORY_START = 'TRANSACTION_HISTORY_START';
export const TRANSACTION_HISTORY_ERROR = 'TRANSACTION_HISTORY_ERROR';
export const TRANSACTION_HISTORY_SUCCESS =
  'TRANSACTION_HISTORY_SUCCESS';
